// @ts-nocheck

// -- Submit / gift message validation/prompt --------

(function () {
	let hasShownGiftCardPrompt = false;

	// Returns true if will add gift message (accepted prompt)
	function promptForGiftMessage() {
		return new Promise(resolve => {
			if (
				!hasShownGiftCardPrompt &&
				!window.hasGiftMessage &&
				!window.isWholesaleCustomer
			) {
				Swal.fire({
					showDenyButton: true,
					allowOutsideClick: false,
					allowEscapeKey: false,
					buttonsStyling: false,
					title: 'Did you forget to leave a gift message?',
					confirmButtonText: 'Leave a gift message',
					denyButtonText: 'Continue checkout',
					closeButtonHtml: `{% render 'icons.svg', icon: 'close' %}`,
					showCloseButton: true,
					customClass: {
						container: 'eb-updated',
						title: 'eb-body--mono fs-body--3 ln-medium text-center',
						confirmButton: 'button button--pink',
						denyButton: 'button',
					},
				})
					.then(result => {
						if (result.isConfirmed) {
							window.openGiftMessage();
							resolve(true);
						} else {
							resolve(false);
						}
					})
					.catch(error => {
						console.error(error);
						resolve(false);
					});
			} else {
				resolve(false);
			}
		});
	}

	// Init cart submit listeners
	[...document.querySelectorAll('button[name="checkout"]')].forEach(function (
		button
	) {
		button.addEventListener('click', async function (event) {
			event.preventDefault();

			// 1. Handle gift message window still open
			if (window.hasUnconfirmedGiftMessage) {
				alert('Please confirm or cancel your gift message.');
				return false;
			}

			// 2. If no gift message added, prompt, or submit.
			const willAddGiftMessage = await promptForGiftMessage();
			if (!willAddGiftMessage) {
				button.disabled = true;
				button.form.action = '/checkout';
				button.form.submit();
			}
		});
	});
})();
